export default __webpack_public_path__ + "static/share-fdeee5f3daeba6264bf1790a03a9b865.jpg";